module.exports = __webpack_public_path__ + "static/media/appleStore@3x.f4308761.png";